<template style="font-family:Almarai">
    <div>
     
      <div id="data-list-list-view" class="data-list-container">
        <vs-table ref="table" id="Scroll" pagination :max-items="itemsPerPage" search :data="ServiceProvidersBankTransfers">
          <template slot="thead">
            <vs-th style="font-size: 16px; font-family: Almarai; color: green;" sort-key="Name">{{ $t("ServiceProviderName") }}</vs-th>
            <vs-th style="font-size: 16px; font-family: Almarai; color: green;" sort-key="PackgName">{{ $t("PackgName") }}</vs-th>
            <vs-th style="font-size: 16px; font-family: Almarai; color: green;" sort-key="TransferedAmount">{{ $t("TransferedAmount") }}</vs-th>
            <vs-th style="font-size: 16px; font-family: Almarai; color: green;" sort-key="TransferDate">{{ $t("TransferDate") }}</vs-th>
            <vs-th style="font-size: 16px; font-family: Almarai; color: green;" sort-key="Image">{{ $t("TrannferImage") }}</vs-th>
            <vs-th style="font-size: 16px; font-family: Almarai; color: green;" sort-key="ConfirmTransfer">{{ $t("ConfirmTransfer") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p style="font-size: 16px; font-family: Almarai;">{{ tr.ServicesProvider.NameAR }}</p>
                </vs-td>
                <vs-td>
                  <p style="font-size: 16px; font-family: Almarai;">{{ tr.subscriptionPeriod.Name }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.subscriptionPeriod.Price }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-name font-medium truncate">{{ new Date(tr.CreatedDate).toLocaleDateString('en-GB') }}</p>
                </vs-td>
                <vs-td>
                  <feather-icon
    icon="EyeIcon"
   @click="openImage(`${baseURL}/${tr.BankTransferImage}`)"
    class="icon-view-image"
  />
  <div  class="tooltip">عرض ايصال التحويل</div>
                </vs-td>
                <vs-td>
                  <vs-checkbox
    v-model="tr.IsTransfered"
    @change="openConfirmTransfer(tr)"
  />
  
                </vs-td>
              </tr>
            </tbody>
          </template>
        </vs-table>
      </div>
      <div v-if="isImageModalVisible" class="image-modal">
      <div class="modal-content">
        <button class="close-button" @click="closeImage">&times;</button>
        <img :src="selectedImage" alt="Full Image" class="modal-image" />
      </div>
    </div>
    </div>
  </template>
  
  
  <script>
  import { domain } from "@/gloabelConstant.js";
  import moduleBankTransfers from "@/store/BankTransfers/moduleBankTransfers.js";  
  export default {
    data() {
      return {
        itemsPerPage: 10,
        rowDataForDelete: {},
        isImageModalVisible: false, // للتحكم في عرض النافذة
      selectedImage: "", // لتخزين رابط الصورة المختارة
        baseURL: domain,
        search: {
          Name: "",
          BrokerPackageType: ""
        },
        rowDataForConfirmTransfer:{},
        //BrokerPackageTypeOptions: [],
        isMounted: false
      };
    },
    computed: {
      ServiceProvidersBankTransfers() {
        return this.$store.state.ServiceProvidersBankTransferList.BankTransfersSPs;
      }
    },
    methods: {
      cleanImagePath(path) {
  return path.replace(/["']/g, "").replace(/\/+/g, "/");
},
openImage(image) {
  const cleanedImage = this.cleanImagePath(image);
  this.selectedImage = cleanedImage;
  this.isImageModalVisible = true;
}
,
    closeImage() {
      this.isImageModalVisible = false; // إخفاء النافذة
    },
    openConfirmTransfer(data) {
      this.rowDataForConfirmTransfer = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "تأكيد", // Title in Arabic
        text: "هل تريد تأكيد التحويل؟", // Message in Arabic
        acceptText: "نعم", // Accept button text in Arabic
        cancelText: "لا", // Cancel button text in Arabic
        accept: this. acceptAlertConfirmTransfer,
       
      });
    },
    
    acceptAlertConfirmTransfer() {
      this.ConfirmTransfer(this.rowDataForConfirmTransfer);
      this.$vs.notify({ time:8000,
        color: "success",
        title: "تم تأكيد التحويل",
        text: "تم تأكيد التحويل المستخدم بنجاح",
      });
    },
   
    ConfirmTransfer(data) {
      debugger;
        this.$store.dispatch("ServiceProvidersBankTransferList/ConfirmTransferSPs", data.Id).then(() => {
        this.$store.dispatch("ServiceProvidersBankTransferList/fetchDataListItemsServiceProviders");
        })
        .catch((err) => {
          console.error(err);
          this.$store.dispatch("ServiceProvidersBankTransferList/fetchDataListItemsServiceProviders");
        });
      },
    },
    created() {
      if (!moduleBankTransfers.isRegistered) {
        this.$store.registerModule("ServiceProvidersBankTransferList", moduleBankTransfers);
        moduleBankTransfers.isRegistered = true;
      }
      // Fetch data from store
      this.$store.dispatch("ServiceProvidersBankTransferList/fetchDataListItemsServiceProviders");
      
    },
    mounted() {
      this.isMounted = true;
    }
  };
  </script>
  
  <style lang="scss">
  .image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  background-color: white;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  max-width: 50%; /* تصغير العرض */
  max-height: 50%; /* تصغير الارتفاع */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-image {
  max-width: 90%; /* التحكم في حجم الصورة داخل النافذة */
  max-height: 90%;
  border-radius: 5px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #333;
}

.close-button:hover {
  color: #ff0000;
}
.tooltip {
    
  background-color: #333; /* Dark background */
  color: #fff; /* White text */
  text-align: center; /* Align text to the right */
  border-radius: 4px;
  padding: 10px; /* Increase padding for a larger tooltip */
  font-size: 12px; /* Increase font size */
  max-width: 250px; /* Max width of the tooltip */
  width: auto; /* Allow the width to adjust based on content */
  white-space: normal; /* Allow text to wrap */
  word-wrap: break-word; /* Break long words onto the next line if necessary */
  position: absolute;
  bottom: 125%; /* Position above the icon */
  right: 0; /* Align to the right side of the container */
  transform: translateX(0); /* Ensure the tooltip is aligned correctly */
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s;
}
  #data-list-list-view small {
    color: rgb(255, 115, 0);
    text-decoration: underline rgb(255, 115, 0);
  }
  .toggle-switch {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 24px;
  }
  
  .toggle-switch input {
    display: none;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #28C76F;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 24px;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
  }
  
  input:checked + .slider {
    background-color: #FF6347;
  }
  
  input:checked + .slider:before {
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }
  
  .vxCard:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0%;
    margin-left: 10%;
    z-index: 500000;
    width: 25%;
    height: 20%;
    border-top: 3px solid rgb(255, 115, 0) !important;
    border-bottom: 0 none rgba(255, 0, 0, 0.9) !important;
    border-right: 0 none rgba(255, 0, 0, 0.9) !important;
    border-left: 0 none rgba(0, 0, 0, 0.9) !important;
  }
  
  #data-list-list-view {
    .vs-con-table {
      .product-name {
        max-width: 23rem;
      }
  
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }
  
        .vs-table--search {
          padding-top: 0;
  
          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;
  
            & + i {
              left: 1rem;
            }
  
            &:focus + i {
              left: 1rem;
            }
          }
        }
      }
  
      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
  
        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
          td {
            padding: 20px;
            &:first-child {
              border-top-left-radius: 0.5rem;
              border-bottom-left-radius: 0.5rem;
            }
            &:last-child {
              border-top-right-radius: 0.5rem;
              border-bottom-right-radius: 0.5rem;
            }
          }
          td.td-check {
            padding: 20px !important;
          }
        }
      }
      .custom-label {
        font-size: 10px;
        margin-bottom: 10px;
      }
      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;
  
          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check {
          padding: 0 15px !important;
        }
        tr {
          background: none;
          box-shadow: none;
        }
      }
  
      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
  </style>
  